import { throwNotInstance } from '@esm-test/guards';
import { TestCollection } from '../../parser/models/testCollection.js';
import { TestParserOptions } from '../../options/testParserOptions.js';

/**
 * Contextual information used during the pre-processing phase of test extraction.
 */
export class PreProcessContext {
  /** The collection where discovered tests are being accumulated. */
  tests: TestCollection;
  /** The configuration options for the parser. */
  options: TestParserOptions;

  /**
   * Initializes a new PreProcessContext.
   * @param tests - The test collection to populate.
   * @param options - Parser options.
   */
  constructor(tests: TestCollection, options: TestParserOptions) {
    throwNotInstance("tests", tests, TestCollection);
    throwNotInstance("options", options, TestParserOptions);

    this.tests = tests;
    this.options = options;
  }

  /**
   * Determines if a property name matches one of the configured built-in test runner functions.
   * 
   * @param name - The property name.
   * @returns True if it's a built-in function.
   */
  isBuiltInFunction(name: string): boolean {
    return this.options.builtInFunctions.includes(name);
  }

}
